import {Component, OnDestroy, OnInit} from "@angular/core";
import {LanguageCode} from "../../../../shared-gen/Model/Localization/LanguageCode";
import {StatusListener} from "../../../status-listener";
import {AppService} from "../../../services/app.service";


@Component({
	selector: "kkb-tur-language-switcher",
	templateUrl: "./tur-language-switcher.component.html",
	styleUrls: ["./tur-language-switcher.component.scss", "../../../pages/tur/tur.scss", "../tur.components.scss"]
})
export class TurLanguageSwitcherComponent extends StatusListener implements OnInit, OnDestroy {

	language = LanguageCode.DE;
	languageLowerCase = this.language.toLowerCase();
	visibility: "" | "popupVisible" = "";
	popupTimeout;

	constructor(app: AppService) {
		super(app);
		this.language = app.translation.getLanguageCode();
		this.languageLowerCase = this.language.toLowerCase();
	}

	toggleLanguagePopup() {
		clearTimeout(this.popupTimeout);
		this.visibility = this.visibility === "popupVisible" ? "" : "popupVisible";

		//Hide hide after 5 seconds
		if (this.isPopupVisible(this.visibility)) {
			this.popupTimeout = setTimeout(() => {
				this.visibility = "";
			}, 5000);
		}
	}

	setLanguage(language: string | LanguageCode) { // string needed for HTML template
		this.language = language as LanguageCode;
		this.languageLowerCase = this.language.toLowerCase();
		this.app.translation.setLanguageCode(this.language);
		this.toggleLanguagePopup();
		this.app.api.deviceApi.userAction();
	}

	private isPopupVisible(popup) {
		return popup === "popupVisible";
	}

}
